const useDataDevice = () => {
  const getBrowserName = (): string => {
    const userAgent = navigator.userAgent;
  
    const browsers: { [key: string]: string } = {
      "Chrome": "Google Chrome",
      "Firefox": "Mozilla Firefox",
      "MSIE": "Internet Explorer",
      "Trident": "Internet Explorer",
      "Edge": "Microsoft Edge",
      "Safari": "Safari",
      "Opera": "Opera",
      "YaBrowser": "YaBrowser"
    };
    for (const [key, value] of Object.entries(browsers)) {
      if (userAgent.indexOf(key) !== -1) {
        return value;
      }
    }
    return "Others";
  };
  const getOS = (): string => {
    const userAgent = window.navigator.userAgent;
    const platform = window.navigator.platform;
  
    const osMapping: { [key: string]: string } = {
      "Mac": "Mac OS",
      "iPhone": "iOS",
      "iPad": "iOS",
      "iPod": "iOS",
      "Win": "Windows",
      "Android": "Android",
      "Linux": "Linux"
    };
 
    for (const [key, value] of Object.entries(osMapping)) {
      if (platform.includes(key) || (key === "Android" && /Android/.test(userAgent))) {
        return value;
      }
    }

    return "Other";
  };

  return {
    getBrowserName,
    getOS,
  };
};

export default useDataDevice;
